/*
 * @Auther: 罗耀祖
 * @Date: 2021-11-09 09:38:42
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-03-17 11:05:46
 * @name: 装饰器
 * @Description: 装饰器
 * @FilePath: \preSaleNafterSaleBackstage\src\utils\decorator.js
 * @Author: desktop
 */
import { MessageBox } from 'element-ui';
import { debounce } from "lodash";

/**
 * @Auther: 罗耀祖
 * @LastEditors: 罗耀祖
 * @description: 弹窗确认
 */
export function confirmation(message, type = 'warning') {
  return function (target, name, descriptor) {
    let oldValue = descriptor.value;
    descriptor.value = function (...args) {
      let myMsg = '';
      if (typeof (message) === 'function') {
        myMsg = message(...args);
      } else {
        myMsg = message;
      }
      MessageBox.confirm(myMsg, '提示', {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type,
      })
        .then(() => { oldValue.call(this, ...args) })
        .catch(() => { });
    };
    return descriptor;
  }
}
/**
 * @Auther: 罗耀祖
 * @LastEditors: 罗耀祖
 * @description: 防抖
 */
export function debounceation(delay = 300, leading = true, trailing = false) {
  return function (target, name, descriptor) {
    let oldValue = descriptor.value;
    descriptor.value = debounce(function (...args) {
      oldValue.call(this, ...args)
    }, delay, { leading, trailing })
    return descriptor;
  }
}
/**
 * @Auther: 罗耀祖
 * @LastEditors: 罗耀祖
 * @description: 调用api方法
 */
export function apiMethod(method) {
  return function (target, name, descriptor) {
    descriptor.promise = true;
    let oldValue = descriptor.value;
    const showLog = (response, request) => {
      if (descriptor.log && process.env.NODE_ENV === 'development') {
        console.log({ request, response });
      }
    }
    descriptor.value = function (params) {
      return new Promise((resolve, reject) => {
        method(params).then(res => {
          showLog(res, params);
          oldValue.call(this, res, params)
          resolve(res, params);
        }).catch(err => {
          showLog(err, params);
          oldValue.call(this, err, params)
          reject(err, params);
        })
      })
    }
    return descriptor;
  }
}
/**
 * @Auther: 罗耀祖
 * @LastEditors: 罗耀祖
 * @description: 打印log
 */
export function log() {
  return function (target, name, descriptor) {
    let oldValue = descriptor.value;
    // 函数为异步使函数log属性为true,否则直接打印输入输出
    if (descriptor.promise) {
      descriptor.log = true;
    } else {
      descriptor.value = function (params) {
        const In = params;
        const Out = oldValue.call(this, params);
        if (process.env.NODE_ENV === 'development') {
          console.log({ In, Out });
        }
      }
    }
    return descriptor;
  }
}
